const restAutoCompleteReducer = (state = [],{type,data}) => {
    switch(type) {
        case 'SET_REST_DATA':
            return data;
        default: 
            return state;
    }
}

export default restAutoCompleteReducer;